    import React, {useContext, useState} from 'react'
import {observer} from 'mobx-react'
import PatientListPageTemplate from '../../../components/Templates/PatientListPageTemplate'
import OrgPatientListStore from '../../../components/Modals/PrintModal/store/OrgPatientListStore'
import {SystemManager_API} from '../SystemManager.API'
import EditPatientCell from '../EditPatinetCell'
import QuizPatientCell from '../../SystemManager/QuizPatientCell'
import {AuthContext} from "../../../context/AuthContext";
    import IconCell from "../../../components/Pages/TablePage/Table/Cells/NewCells/IconCell/IconCell";
    import LinkCell3 from "../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
    import {formatDate, isWaiting} from "../../../utils/utils";


const AllPatients = observer(() => {
    const {getPatient, updatePatient} = SystemManager_API.allPatients
    const [refresh, setRefresh] = useState()
    const {token} = useContext(AuthContext)

    return (
        <>
            <PatientListPageTemplate
				registry={false}
				refresh={refresh}
                getPatientURL={`/api/v2/systemManagers/${token.userId}/patients?`}
                editPatientAPI={{getPatient, updatePatient}}
                filterFieldsConf={{
                    fio: true,
                    verCenter: true,
                    date: true,
                    period: true,
                    org: true,
                    place: true,
                    //medBook: true,
					resultStudyType: true,
                    center: true,
                    result: true,
                    base: true
                }}

                breadCrumbsItems={[
                    {title: 'Пациенты'},
                    {title: 'Все', actual: true}
                ]}

                tableModel={{

                    firstRow: [
                        {title: 'ФИО', id: 'fio'},
                        {title: 'Дата рождения', id: 'dob'},
                        // {title: 'Мед. книжка', id: 'med_book'},
						{title: 'Обследование', id: 'result_study_type'},
                        {title: 'Организация', id: 'organization'},
                        {title: 'Мед центр', id: 'medCenter'},
                        {title: 'Дата прохождения', id: 'result_date'},
                        {title: 'Результат', id: 'result'},
                        {title: 'Распечатать', id: ''}],

                    haveToShow: [
                        {
                            id: 'patient', type: 'wrapperCell',
                            typeData: {
                                cell: props => <EditPatientCell patientId={props.all.patient.id}
                                                                resultId={props.all.id}
                                                                API={{getPatient, updatePatient}}
                                                                closeCallback={_ => setRefresh(!refresh)}
                                                                label={props.all.patient.fio}/>
                            }
                        },
                        {id: 'patient', type: 'arrCell', typeData: {show: 'dob', id: 'id'}},
                        // {id: 'patient', type: 'arrCell', typeData: {show: 'med_book', id: 'id'}},
						{id: 'results', type: 'arrCell', typeData: {show: 'result_study_type', id: 'id'}},
                        {id: 'organization', type: 'arrCell', typeData: {show: 'name', id: 'id'}},
                        {id: 'medcenter', type: 'arrCell', typeData: {show: 'name', id: 'id'}},
                        {id: 'results', type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={formatDate(props.all?.results?.result_date)}/>}},
                        {id: 'results', type: 'resultStatusCell', typeData: {show: 'result', id: 'id'}},
                        {
							id: 'results',
                            typeData: {
								cell: props => !isWaiting(props?.all?.results?.result) ? 
									<IconCell iconName={"printer"} onClick={() => OrgPatientListStore.showPrintModal( props.all.id, props.all.patient.id,  )}/> 
									: (props?.all?.results?.study_type && props?.all?.results?.study_type.endsWith("-очередь") ? 
										<QuizPatientCell 
											studyType={props?.all?.results?.study_type}
											patientId={props.all.patient.id}
											resultId={props.all.id}
											API={SystemManager_API.allPatients}
											closeCallback={() => {
												setRefresh(!refresh)
											}}/>: ""),
							},
                            type: 'wrapperCell'
                        }
                    ]
                }}
            />
        </>
    )
})
export default AllPatients

